<script>
  import ClickOut from '../../../../utils/directives/clickout'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
    <li class="dropdown" :class="{ open: open }">
        <a href="javascript://" v-click-out="hide" @click="toggle" class="dropdown-toggle">
            <i class="icon-bell fa-fw"></i> <span class="visible-xs-inline">Notificações</span>
            <span class="badge badge-sm up bg-danger pull-right-xs">1</span>
        </a>
        <!-- dropdown -->
        <div class="dropdown-menu w-xl">
            <div class="panel bg-white animated fadeInRight">
                <div class="panel-heading b-light bg-light"><strong>Você tem <span>1</span> notificação</strong></div>
                <div class="list-group">
                    <a href="javascript://" class="list-group-item">
                        <span class="label bg-light">Dev Team</span>
                        <span class="clear block m-b-none">
                          Pessoal, o sistema de notificação está desativado temporariamente<br>
                            <small class="text-muted">1 hora atrás</small>
                        </span>
                    </a>
                </div>
                <div class="panel-footer text-sm">
                    <a href="javascript://" class="pull-right"><i class="fa fa-cog"></i></a>
                    <a href="javascript://" data-toggle="class:show animated fadeInRight">Ver todas as notificações</a>
                </div>
            </div>
        </div>
        <!-- / dropdown -->
    </li>
</template>




// WEBPACK FOOTER //
// Notification.vue?10e37a2e